import sx from 'utils/createSx';

export const LIST_ITEM_TEXT_PRIMARY = {
  variant: 'subtitle1' as const,
  sx: { fontWeight: 600 },
};

export default sx({
  pageContainer: { py: 3 },
  pageTitle: { fontWeight: 600 },
  filtersPaper: { p: 2, borderRadius: 2, mb: 2 },
  filtersStack: { alignItems: { xs: 'stretch', sm: 'center' } },
  filterButton: { minWidth: { sm: 120 } },
  listPaper: { p: 1, borderRadius: 2, minHeight: 200 },
  paginationWrap: { display: 'flex', justifyContent: 'center', mt: 2 },
  loadingBox: { display: 'flex', justifyContent: 'center', py: 6 },
  emptyState: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 1,
    py: 6,
    color: 'text.secondary',
  },
  emptyIcon: { fontSize: 48, opacity: 0.5 },
  listItemPaper: {
    mb: 1,
    borderRadius: 2,
    flexDirection: 'row',
    alignItems: 'center',
    gap: 1,
  },
  listAvatar: { bgcolor: 'primary.light' },
});
